import React, { useState } from "react";
import {
  Button,
  CssBaseline,
  TextField,
  Box,
  Typography,
  Container,
  createTheme,
  ThemeProvider,
} from "@mui/material";
import Logo from "../../../Assets/Logo.png";
import { useEntidade } from "../../../Hooks/EntidadeHook";
import { useUsuarioNaoEmiteNota } from "../../../Hooks/UsuarioNaoEmiteNotaHook";

const defaultTheme = createTheme();

export const LoginNaoEmitoNotaFiscal = () => {
  const { entidade } = useEntidade();
  const { login } = useUsuarioNaoEmiteNota();

  const [cpfCnpj, setCpfCnpj] = useState("");
  const [codigoCadastro, setCodigoCadastro] = useState("");

  // Função para remover pontuação e deixar apenas números
  const sanitizeCpfCnpj = (value: string) => {
    return value.replace(/[^\d]/g, ""); // Remove tudo que não for número
  };

  const handleLogin = () => {
    const cleanCpfCnpj = sanitizeCpfCnpj(cpfCnpj); // Limpa antes de enviar
    login(cleanCpfCnpj, Number(codigoCadastro));
  };

  return (
    <ThemeProvider theme={defaultTheme}>
      <Container component="main" maxWidth="sm">
        <CssBaseline />
        <Box
          sx={{
            marginTop: 10,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: 3,
            boxShadow: 3,
            borderRadius: 2,
            backgroundColor: "#fff",
          }}
        >
          <img src={Logo} style={{ width: "140px", marginBottom: 16 }} />
          <Typography component="h1" variant="h5" gutterBottom textAlign="center">
            Não emito nota fiscal em{" "}
            {entidade?.titulo?.replace("Prefeitura -", "")}
          </Typography>

          <Box component="form" noValidate sx={{ mt: 3, width: "100%" }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="CPF ou CNPJ"
              value={cpfCnpj}
              onChange={(e) => setCpfCnpj(e.target.value)}
              placeholder="Digite seu CPF ou CNPJ"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Código de Cadastro Único"
              value={codigoCadastro}
              onChange={(e) => setCodigoCadastro(e.target.value)}
              placeholder="Digite o código recebido"
            />
            <Button
              type="button"
              fullWidth
              variant="contained"
              sx={{ mt: 3, mb: 2 }}
              onClick={handleLogin}
            >
              ENTRAR
            </Button>
          </Box>
        </Box>
      </Container>
    </ThemeProvider>
  );
};